'use client';

import React from 'react';
import { Question } from '../types';
import { getQuestionText } from '../utils/questionUtils';

interface QuestionDisplayProps {
  question: Question;
  questionIndex: number;
  questionType: string | null;
}

/**
 * Reusable component for displaying question number and text
 * Used in both AssessmentQuestion and AssessmentResults
 */
export function QuestionDisplay({
  question,
  questionIndex,
  questionType,
}: QuestionDisplayProps) {
  const questionText = getQuestionText(question, questionType);

  return (
    <div className="flex flex-col gap-1">
      <h6 className="cs-h6 select-none text-text-default-light">
        Question {questionIndex + 1}
      </h6>
      <p className="cs-m-body text-text-default-strong select-none">{questionText}</p>
    </div>
  );
}

